import { render, staticRenderFns } from "./SelecaoAssinatura.vue?vue&type=template&id=2f171f1b&scoped=true&"
var script = {}
import style0 from "./SelecaoAssinatura.vue?vue&type=style&index=0&id=2f171f1b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f171f1b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
